import { IonApp, setupIonicReact } from "@ionic/react";

import Routes from "./routes";

import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";

import '../src/styles/VerifyLoginComponent.css'
import '../src/styles/UserSignInComponent.css'
import '../src/styles/style.css'

import { RecoilRoot } from "recoil";
import RecoilizeDebugger from "recoilize";

setupIonicReact();

function App() {
  return (
    <RecoilRoot>
      <RecoilizeDebugger />
      <IonApp>
        <Routes />
      </IonApp>
    </RecoilRoot>
  );
}

export default App;
